import { ADYEN_HOSTED } from '@constants/adyen-hosted.constants';
import { AdyenHostedMessage } from '@models/adyen.model';

/**
 * The origin the hosted-return page is served from: the Calenso API itself (`restAPI` minus its
 * path). Null for a value that is not an absolute URL - the caller then accepts no message at all
 * and relies on polling, rather than accepting one from anywhere.
 */
export function adyenApiOrigin(restApi: string | undefined): string | null {
  try {
    const origin = new URL(restApi ?? '').origin;

    return origin && origin !== 'null' ? origin : null;
  } catch {
    return null;
  }
}

/**
 * The session result carried by a hosted-return message, or null when the message is not the one
 * this checkout is waiting for. Every field is checked: the listener sits on the partner's page,
 * where any frame or window can post anything.
 */
export function adyenHostedMessageResult(
  event: Pick<MessageEvent, 'origin' | 'data'>,
  expectedOrigin: string | null,
  nonce: string,
  sessionId: string,
): string | null {
  if (!expectedOrigin || event.origin !== expectedOrigin) {
    return null;
  }

  const data = event.data as Partial<AdyenHostedMessage> | null;
  if (
    !data
    || typeof data !== 'object'
    || data.source !== ADYEN_HOSTED.MESSAGE_SOURCE
    || data.nonce !== nonce
    || data.sessionId !== sessionId
    || typeof data.sessionResult !== 'string'
    || data.sessionResult === ''
  ) {
    return null;
  }

  return data.sessionResult;
}
